<div
  #trigger
  class="search"
  cdkOverlayOrigin
  [class.focused]="state.searchVisible()"
>
  <mat-form-field
    class="form-field"
    appearance="outline"
    subscriptSizing="dynamic"
  >
    <input
      #input
      class="input"
      type="text"
      matInput
      [formControl]="searchControl"
      (focus)="state.showSearch()"
      (keydown.Tab)="acceptAutocomplete($event)"
    />
    @if (autocomplete(); as autocomplete) {
      <div class="autocomplete">{{ autocomplete }}</div>
    }
    @if (!searchControl.value) {
      <mat-icon
        class="icon"
        matSuffix
        (click)="search()"
      >
        search
      </mat-icon>
    } @else {
      <mat-icon
        class="icon"
        matSuffix
        (click)="clearInput()"
      >
        close
      </mat-icon>
    }
  </mat-form-field>
  <ng-template
    cdkConnectedOverlay
    cdkConnectedOverlayHasBackdrop
    [cdkConnectedOverlayUsePopover]="null"
    [cdkConnectedOverlayWidth]="trigger.offsetWidth"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="state.searchVisible()"
    (overlayOutsideClick)="clear($event)"
    (detach)="clear()"
  >
    <procure-search-overlay />
  </ng-template>
</div>
